module.controller('achCtrl', ['$scope', '$state', '$http', 'cacheService', 'Transform', 'baseURI', 'OVERLAY', '$rootScope', 'accountService', '$stateParams', function ($scope, $state, $http, cacheService, Transform, baseURI, OVERLAY, $rootScope, accountService, $stateParams){
  var achUrl = baseURI + 'consumer-choice/bank';

  $scope.alert = {};

  $scope.alert.alertMessage = 'Sorry, we were unable to process the transfer at this time.  If you continue to experience this issue, please call customer service ' + $scope.brand.programContactPhone + '.';

  var account = null;
  $scope.formData = {};

  accountService.initializeAccounts(function(err, accounts){
    if(err){
      return;
    }
    account  = accountService.getAccount($stateParams.username);
    $scope.formData.Amount = account.balance;
    $scope.availableBalance = account.balance;
  });


  $scope.overlay = OVERLAY['member.home.ach'];

  $scope.amountValid = true;

  // Adds context to the amount messaging
  $scope.formatAmountMessage = function(){
    if (!account) {
      return;
    }

    if ($scope.formData.Amount > account.balance){
      $scope.amountValid = false;
      $scope.amountMessage = 'Oops, there\'s not enough on your ' + $scope.brand.commonProgramName + '.';
    } else {
      $scope.amountValid = true;
      $scope.amountMessage = 'ok';
    }
  };

  $scope.validateRouting = function() {
    if(!(/^\d+$/.test($scope.formData.RoutingNumber))){
      $scope.routingValid = false;
      $scope.routingMessage = 'Please Enter Only Numbers';
    } else if($scope.formData.RoutingNumber.length !== 9) {
      $scope.routingValid = false;
      $scope.routingMessage = "Please confirm your routing number by looking at your personal checks. If you've confirmed the routing number on your checks is correct, please place a zero in front of your routing number to make it 9-digits.";
    } else {
      $scope.routingValid = true;
    }
  };

  $scope.typeOptions = [
    {
      key: 'checking',
      label: 'Checking'
    },
    {
      key: 'savings',
      label: 'Savings'
    },
  ];

  $scope.confirmAccount = function(){
    if ($scope.formData.AccountNumber !== $scope.formData.AccountConfirm) {
      $scope.accountValid = false;
    } else {
      $scope.accountValid = true;
    }
  };

  $scope.attemptSubmission = function (formData){
    $scope.validateRouting();
    if(formData.$valid && $scope.routingValid && $scope.amountValid && $scope.accountValid){
      $scope.alert.errorShown = false;
      $state.go('member.home.ach.step2', $scope.formData);
    } else {
      $scope.alert.errorShown = true;
      $scope.attempted = true;
    }
  };

  // Review and submit
  $scope.processForm = function(){
    $scope.loading = true;

    var data = {};
    data.AccountName = $scope.formData.AccountName;
    data.Routing = $scope.formData.RoutingNumber;
    data.Account = $scope.formData.AccountNumber;
    data.AccountType = $scope.formData.AccountType.key;
    data.Amount = $scope.formData.Amount;
    data.Username = $stateParams.username;

    $http({
      method: 'POST',
      url: achUrl,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      },
      data: Transform.encode(data)
    }).then(function (resp){
      var data = resp.data;

      $scope.loading = false;
      if(data.Success){
        cacheService.clear('subcard');
        $scope.mainBtn = false;
        $scope.cancel = false;
        $scope.close = true;
        $scope.alert.successMessage = 'Transfer in progress';
        $scope.alert.successShown = true;
      } else {
        $scope.invalidRequest = true;
      }
    }).catch(function (error){
      $scope.loading = false;
      $scope.alert.alertShown = true;
    });
  };
}]);
